exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiSelectContent__item___1M3rs {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  height: 50px;\n  align-items: center; }\n  .multiSelectContent__item___1M3rs > label {\n    font-size: 15px; }\n\n.multiSelectContent__itemGroup___2cm5p {\n  width: 100%;\n  overflow-x: hidden; }\n\n.multiSelectContent__groupHeader___2uuyq {\n  font-weight: 600;\n  font-size: 14px;\n  color: #1a1a1a;\n  padding: 12px 10px 8px 10px;\n  border-bottom: 1px solid #f0f0f0;\n  margin-bottom: 4px; }\n\n.multiSelectContent__checkboxGroup___2-grV {\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"item": "multiSelectContent__item___1M3rs",
	"itemGroup": "multiSelectContent__itemGroup___2cm5p",
	"groupHeader": "multiSelectContent__groupHeader___2uuyq",
	"checkboxGroup": "multiSelectContent__checkboxGroup___2-grV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiSelectModal/styles/multiSelectContent.scss
// module id = 2127
// module chunks = 6